/**
 * DEPLETIONS-INVENTORY MODULE
 * Self-contained. Import only from /shared or within this module.
 * Do not import from other modules directly.
 */

import { useNavigate } from "react-router-dom";
import DepletionsPage from "../components/DepletionsPage.jsx";

// Depletions screen — monthly case-sales by state / flavor / size / pack.
export default function Depletions() {
  const navigate = useNavigate();
  return <DepletionsPage onHome={() => navigate("/")} />;
}
